import React, { useEffect, useState } from 'react'
import { useIndexedDB } from '../../../context/IndexedContext'
import Graytextarea from '../../../components/Graytextarea'
import HighLightText from '../../../components/shared/HighLightText'

const PoacRecords = ({ patientDBdata, isSavingTheData, diagnosis, questionValue, setQuestionsValue, patientID, MasterDiagnosisData, loggedUserProvider, setPatientDBdata, noteID }) => {

    const { getCallCenterQuestions, saveCallCenterQuestions } = useIndexedDB()
    const [patientDiagnosis, setPatientDiagnosis] = useState([])

    useEffect(() => {
        const patientD = patientDBdata?.patientData?.Diagnosis?.split(',')
        setPatientDiagnosis(patientD)
    }, [])

    const getLatestDataForPoa = (allPatientHpiData, patientID,) => {

        const filtered = allPatientHpiData.filter((item) => {
            const patientData = item[patientID]
            // /  return patientData && patientData[noteID]
            return patientData
        })
        console.log(filtered, 'filtered getLatestNoteByPatientAndNoteID')

        const latest = filtered.at(-1)
        console.log(latest, 'latest getLatestNoteByPatientAndNoteID')
        return latest || null
    }

    const getCallCenterDatas = async (diagnosisList) => {

        // let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '');
        // let data = await getCallCenterQuestions();
        // let allData = JSON.parse(data?.d);

        let allData = await getCallCenterQuestions();
        console.log('patinet id allData ', allData);

        const allPatientHpiData = allData?.Data?.map((item) => {
            return {
                ...JSON.parse(item?.JsonData),
                CreatedAt: item?.CreatedAt,
            };
        });

        const result = getLatestDataForPoa(allPatientHpiData, patientID);

        console.log("call center latest data ---> ", result);


        const convertedData = {};

        const callCenterData = result?.[patientID]?.CCENTER;
        const globalFreeType = result?.[patientID]?.globalFreeType


        setQuestionsValue(callCenterData);
        console.log("Converted Call Center Data", convertedData);



        return convertedData;
    };
    useEffect(() => {
        if (Array.isArray(patientDiagnosis) && patientDiagnosis.length > 0) {
            getCallCenterDatas(patientDiagnosis)
        }
    }, [patientDiagnosis])


    return (
        <div className='d-flex flex-column gap-2'>
            {questionValue?.[diagnosis] && <p>POA</p>}
            <div className='d-flex flex-column gap-2'>
                {(questionValue?.[diagnosis] || []).map((item, idx) => (
                    <div key={idx} className='d-flex flex-column gap-1'>
                        {item?.freewayRemark && <div>{item.freewayRemark}</div>}
                        <p className='p-0 m-0'>
                            {item.type === "Header"
                                ? item.label
                                : item.type === "subHeader"
                                    ? `${item.label} :`
                                    : `${item.label} -`}
                        </p>
                        {item?.answer &&
                            <HighLightText
                                style={{ width: '100%', height: "80px", background: '#2D2D2D', border: 0, color: 'white', overflow: "hidden" }}
                                // onChange={(e) => {
                                //     const updatedQuestionsValue = { ...questionValue };
                                //     updatedQuestionsValue[diagnosis][idx].answer = e.target.value;
                                //     setQuestionsValue(updatedQuestionsValue);
                                // }}
                                onChange={(e) => {
                                    setQuestionsValue(prev => ({
                                        ...prev,
                                        [diagnosis]: prev?.[diagnosis]?.map((q, i) =>
                                            i === idx ? { ...q, answer: e } : q
                                        )
                                    }));
                                }}

                                value={item?.answer}
                                callingName = 'providerEditNoteView'
                            />
                        }
                    </div>
                ))}
            </div>
        </div>
    )

}

export default PoacRecords